"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexWrapExtender = void 0;
/**
 * FlexWrapExtender
 * Leverage for cases where you have a flex-wrapped group of elements that you want to expand or collapse without
 * weird gaps or breaks in content. This is in contrast to the Extender component which will only handle cases
 * where you have a single item per row, vertical column of elements.
 */
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var styled_components_1 = __importDefault(require("styled-components"));
var ContentListContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
var FlexWrapExtender = function (_a) {
    var collapseLabel = _a.collapseLabel, expandLabel = _a.expandLabel, testId = _a.testId, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, initialElementCount = _a.initialElementCount, elementList = _a.elementList;
    var _c = (0, react_1.useState)(isOpen), isExpanded = _c[0], setIsExpanded = _c[1];
    if (elementList.length <= initialElementCount) {
        return react_1.default.createElement(ContentListContainer, null, elementList);
    }
    var handleClick = function () {
        setIsExpanded(function (prev) { return !prev; });
    };
    var truncatedList = (0, react_1.useMemo)(function () { return elementList.slice(0, initialElementCount); }, [elementList, initialElementCount]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ContentListContainer, null, isExpanded ? elementList : truncatedList),
        react_1.default.createElement(storm_ui_1.Extender, { "data-testid": testId, label: isExpanded ? collapseLabel : expandLabel, handleClick: handleClick, isOpen: isExpanded },
            react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.FlexWrapExtender = FlexWrapExtender;
var templateObject_1;
